import { put, select, all } from 'redux-saga/effects'
import GlobalActions from 'store/redux/global'
import { push } from 'connected-react-router'
import PhaseInfoActions from 'store/redux/phaseInfo'
import PhaseActions from 'store/redux/phase'
import PHASES from 'utils/constants/phases'
import ERROR from 'utils/errors'
import dataEnhancer from 'utils/dataEnhancer'

export function* onPhaseUpdated({ response }) {
    const { ok, data } = response
    yield put(GlobalActions.cleanModal())
    if (ok) {
        const { uuid, player = {} } = yield select(state => state.auth)
        yield put(PhaseInfoActions.clean())
        yield put(PhaseActions.clean())
        // if (player.nickname) {
        yield all([
            put(PhaseInfoActions.setState(dataEnhancer(data, uuid))),
            put(PhaseActions.setCredits(data.credits))
        ])
        // }
        if (!player.nickname) {
            yield put(push('/onboarding'))
        } else if (data.finished) {
            yield put(push('/loading'))
        } else {
            switch (data.phase) {
                case PHASES.INTRO:
                    yield put(push('/tour'))
                    break
                case PHASES.PRE_SEASON:
                    yield put(push('/pre-season'))
                    break
                case PHASES.PRE_RACE:
                    yield put(push('/pre-race'))
                    break
                case PHASES.RACE:
                    yield put(push('/race'))
                    break
                case PHASES.POST_RACE:
                    yield put(push('/post-race'))
                    break
                case PHASES.POST_SEASON:
                    yield put(push('/post-season'))
                    break
                default:
                    yield put(push('/new-game'))
                    break
            }
        }
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}



// WEBPACK FOOTER //
// src/store/sagas/phaseInfo.js